import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=fc04ac56&scoped=true&"
import script from "./Product.js?vue&type=script&lang=js&"
export * from "./Product.js?vue&type=script&lang=js&"
import style0 from "./Product.scss?vue&type=style&index=0&id=fc04ac56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc04ac56",
  null
  
)

export default component.exports